const activeCalls = new Set();

let holder = null;

export const hasActiveVoiceCall = () => activeCalls.size > 0;

export const trackVoiceCallStart = callId => {
  if (callId) activeCalls.add(callId);
};

export const trackVoiceCallEnd = callId => {
  if (callId) activeCalls.delete(callId);
};

export const holdVoiceSession = surface => {
  holder = surface;
};

export const releaseVoiceSession = surface => {
  if (holder === surface) holder = null;
};

export const isCallRunningIn = surface =>
  hasActiveVoiceCall() && holder === surface;

export const forgetActiveVoiceCalls = () => {
  activeCalls.clear();
  holder = null;
};
